import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Examplad Media Pricing Portal components
import MDBox from "components/MDBox";

// Examplad Media Pricing Portal contexts
import { useMaterialUIController } from "context";
import { colors } from "@mui/material";

function DataTableHeadCell({ width, children, sorted, header, align, ...rest }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      component="th"
      width={width}
      py={1.5}
      px={1}
      sx={({ palette: { light }, borders: { borderWidth }, breakpoints }) => ({
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
        backgroundColor: "#f8f9fa",
        position: "sticky",
        top: 0,
        backgroundColor: "#f8f9fa",
        zIndex: 1100,

        // zIndex: 1100,
        [breakpoints.up("xl")]: {
          ...(header === "Publication"  && {
            position: "sticky",
            left: 0,
            top: 0,
            backgroundColor: "#f8f9fa",
            overflow: "visible",
            borderBottom: `${borderWidth[1]} solid ${light.main}`,
            left: header === "Publication" ? 0 : "unset",
            backgroundColor: "#f8f9fa",
            zIndex: header === "Publication" ? 1200 : 1100,
            borderBottom: `${borderWidth[1]} solid ${light.main}`,
            overflow: header === "Publication" ? "visible" : "hidden",
            // whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            minWidth: header === "Publication" ? "auto" : "auto",
            maxWidth: header === "Publication" ? "none" : "auto",
          }),
        },
      })}
    >
      <MDBox
        {...rest}
        position="relative"
        textAlign={align}
        color={darkMode ? "white" : "secondary"}
        opacity={0.7}
        sx={({ typography: { size, fontWeightBold } }) => ({
          fontSize: size.xs,
          fontWeight: fontWeightBold,
          textTransform: "uppercase",
          cursor: sorted && "pointer",
          userSelect: sorted && "none",
        })}
      >
        <span style={{ color: "black" }}>{children}</span>
        {sorted && (
          <MDBox
            position="absolute"
            top={0}
            right={align !== "right" ? "16px" : 0}
            left={align === "right" ? "-5px" : "unset"}
            sx={({ typography: { size } }) => ({
              fontSize: size.lg,
            })}
          >
            <MDBox
              position="absolute"
              top={-6}
              color={sorted === "asce" ? "text" : "secondary"}
              opacity={sorted === "asce" ? 1 : 0.5}
            >
              <Icon>arrow_drop_up</Icon>
            </MDBox>
            <MDBox
              position="absolute"
              top={0}
              color={sorted === "desc" ? "text" : "secondary"}
              opacity={sorted === "desc" ? 1 : 0.5}
            >
              <Icon>arrow_drop_down</Icon>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableHeadCell
DataTableHeadCell.defaultProps = {
  width: "auto",
  sorted: "none",
  align: "left",
};

// Typechecking props for the DataTableHeadCell
DataTableHeadCell.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  sorted: PropTypes.oneOf([false, "none", "asce", "desc"]),
  align: PropTypes.oneOf(["left", "right", "center"]),
  header: PropTypes.string,
};

export default DataTableHeadCell;
